export default function SEOFoundation() {
  return (
    <section className="py-12 sm:py-20 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-[#1A2B4C] mb-4 sm:mb-6 font-['Playfair_Display']">
            Встроенное SEO: Фундамент вашего бесплатного трафика
          </h2>
          <p className="text-base sm:text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed font-['Montserrat'] text-justify">
            Каждое решение проходит базовую SEO-подготовку, чтобы Google и Яндекс полюбили ваш проект с первого дня.
          </p>
        </div>

        {/* Four Cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {/* Card 1 */}
          <div className="bg-white rounded-3xl p-6 sm:p-8 border border-[#C5A880]/20 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-[#C5A880] rounded-full mb-5 sm:mb-6">
              <i className="ri-search-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-[#1A2B4C] mb-3 sm:mb-4 font-['Playfair_Display']">
              Проектирование под запросы
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed font-['Montserrat'] text-justify">
              Структура сайта строится на основе того, что люди реально ищут в поиске.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-3xl p-6 sm:p-8 border border-[#C5A880]/20 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-[#C5A880] rounded-full mb-5 sm:mb-6">
              <i className="ri-settings-3-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-[#1A2B4C] mb-3 sm:mb-4 font-['Playfair_Display']">
              Техническая чистота
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed font-['Montserrat'] text-justify">
              Настройка мета-тегов, заголовков и скорости загрузки для быстрой индексации.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-3xl p-6 sm:p-8 border border-[#C5A880]/20 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-[#C5A880] rounded-full mb-5 sm:mb-6">
              <i className="ri-google-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-[#1A2B4C] mb-3 sm:mb-4 font-['Playfair_Display']">
              Индексация «под ключ»
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed font-['Montserrat'] text-justify">
              Регистрация сайта в кабинетах для вебмастеров, чтобы он появился в поиске сразу после запуска.
            </p>
          </div>

          {/* Card 4 */}
          <div className="bg-white rounded-3xl p-6 sm:p-8 border border-[#C5A880]/20 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-[#C5A880] rounded-full mb-5 sm:mb-6">
              <i className="ri-map-pin-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-[#1A2B4C] mb-3 sm:mb-4 font-['Playfair_Display']">
              Локальное SEO
            </h3>
            <p className="text-sm sm:text-base text-gray-600 mb-2 sm:mb-3 italic font-['Montserrat']">
              Ваша «вывеска» в городе
            </p>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed font-['Montserrat'] text-justify">
              Мы привяжем ваш бизнес к геолокации, поисковик покажет вас именно тем, кто ищет услугу рядом.
            </p>
          </div>
        </div>

        {/* Result Banner */}
        <div className="bg-gradient-to-br from-[#1A2B4C] to-[#2A3B5C] rounded-3xl p-6 sm:p-10 text-center border-2 border-[#C5A880]">
          <div className="flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 bg-[#C5A880] rounded-full mb-5 sm:mb-6 mx-auto">
            <i className="ri-trophy-line text-3xl sm:text-4xl text-white"></i>
          </div>
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-3 sm:mb-4 font-['Playfair_Display']">
            Результат
          </h3>
          <p className="text-base sm:text-xl text-white/90 leading-relaxed max-w-4xl mx-auto font-['Montserrat'] text-justify">
            Вы получаете технически совершенный ресурс, который готов приводить бесплатных клиентов из поиска, экономя ваш бюджет на рекламу.
          </p>
        </div>
      </div>
    </section>
  );
}